import { useQuery } from '@tanstack/react-query';
import { fetchLocalContentPerformers } from './fetchLocalContentPerformers';
import { GlobalReactQueryOptions } from '../../../../config';
import { browserClient } from '../../../../react-query';

export const LOCAL_CONTENT_PERFORMERS_QUERY_KEY = 'localContentPerformers';

export const useLocalContentPerformers = () => {
    return useQuery([LOCAL_CONTENT_PERFORMERS_QUERY_KEY], fetchLocalContentPerformers, {
        ...GlobalReactQueryOptions
    });
};

export const invalidateLocalContentPerformers = () => {
    return browserClient.invalidateQueries([LOCAL_CONTENT_PERFORMERS_QUERY_KEY]);
};
